import 'babel-polyfill';
import 'intersection-observer';

IntersectionObserver.prototype.POLL_INTERVAL = 100;

// Trim polyfill - https://gist.github.com/sv-in/3898704
''.trim ||
  (String.prototype.trim = function() {
    // Use the native method if available, otherwise define a polyfill:
    // trim returns a new string (which replace supports)
    return this.replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, ''); // trim the left and right sides of the string
  });

exports.onClientEntry = () => {
  window.ga =
    window.ga ||
    function() {
      (ga.q = ga.q || []).push(arguments);
    };
  ga.l = +new Date();

  ga('create', 'UA-112064401-1', 'auto');

  ga('require', 'cleanUrlTracker');
  ga('require', 'eventTracker');
  ga('require', 'impressionTracker');
  ga('require', 'maxScrollTracker');
  ga('require', 'mediaQueryTracker');
  // ga('require', 'outboundFormTracker');
  ga('require', 'outboundLinkTracker');
  ga('require', 'pageVisibilityTracker');
  // ga('require', 'socialWidgetTracker');
  ga('require', 'urlChangeTracker');

  ga('send', 'pageview');
};



// WEBPACK FOOTER //
// ./gatsby-browser.js